
  // custom-product-desc.js
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cat4-spatial-wrapper .mfaq-btn');
    if (!btn) return;

    var item = btn.closest('.mfaq-item');
    if (!item) return;

    item.classList.toggle('open');
  });
})();